import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { Helmet } from "react-helmet";
import "bootstrap/dist/css/bootstrap.min.css";
import RoutesAll from "./RoutesAll";
import { DOMAIN_CLINKS } from "constants/app";
import { getStorageData, setStorageData } from "utils/helper";
const Theme = (props) => {
  const getData = getStorageData("user_data");
  const domain = getStorageData("domain");
  const [formData, setFormData] = useState(
    getData &&
      typeof getData === "object" &&
      !Array.isArray(getData) &&
      Object.keys(getData).length === 0
      ? {
          pathway: [],
          pathway_name: [],
          sub_pathway: [],
          sub_pathway_name: [],
          keyword: [],
          keyword_name: [],
          county: [],
          county_name: [],
          is_clinks: false,
        }
      : getData
  );
  useEffect(() => {
    setStorageData("user_data", formData);
  }, [formData]);
  return (
    <>
      <Helmet>
        <title>
          {DOMAIN_CLINKS === domain
            ? "Clinks | Directory Provided by Make Time Count Today"
            : "Make Time Count Today | We all need help sometimes"}
        </title>
        <meta name="description" content="MTC" />
      </Helmet>
      <RoutesAll formData={formData} setFormData={setFormData} {...props} />
    </>
  );
};
Theme.propTypes = {
  history: propTypes.object.isRequired,
};
export default Theme;
